(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dml-write-review"] && !Shopify.designMode) return;
  try {
    
  const sections = document.querySelectorAll('[data-section-id]');

  sections.forEach((section) => {
    const triggers = section.querySelectorAll('[aria-controls^="doom-modal-"]');
    const modal = section.querySelector('dialog');
    const close = section.querySelector('.write-review-modal-close');

    if (!triggers.length || !modal || !close) return;

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        modal.showModal();
        trigger.setAttribute('aria-expanded', 'true');
      });
    });

    close.addEventListener('click', () => {
      modal.close();
    });

    modal.addEventListener('close', () => {
      triggers.forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'false');
      });
    });

    modal.addEventListener('click', (event) => {
      if (event.target === modal) {
        modal.close();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
(function () {
  // shop-follow-button renders in an open shadow root (registered with
  // `shadow: "open"` in Shopify's shop-js bundle) and hard-codes its label to
  // text-black whenever the visitor already follows the shop, regardless of
  // the host page's background — plain page CSS can't reach inside a shadow
  // root, so we inject an override <style> straight into the shadow root.
  function applyFix(el) {
    if (!el.shadowRoot || el.__dmlFollowFixApplied) return;
    var style = document.createElement('style');
    style.textContent = '.text-black { color: #ffffff !important; }';
    el.shadowRoot.appendChild(style);
    el.__dmlFollowFixApplied = true;
  }

  function watch(el) {
    applyFix(el);
    if (el.__dmlFollowFixApplied) return;
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      applyFix(el);
      if (el.__dmlFollowFixApplied || tries > 50) clearInterval(timer);
    }, 100);
  }

  var button = document.querySelector('.footer__follow-on-shop shop-follow-button');
  if (button) watch(button);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["write-review"] && !Shopify.designMode) return;
  try {
    
  const sections = document.querySelectorAll('[data-section-id]');

  sections.forEach((section) => {
    const triggers = section.querySelectorAll('[aria-controls^="doom-modal-"]');
    const modal = section.querySelector('dialog');
    const close = section.querySelector('.write-review-modal-close');

    if (!triggers.length || !modal || !close) return;

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        modal.showModal();
        trigger.setAttribute('aria-expanded', 'true');
      });
    });

    close.addEventListener('click', () => {
      modal.close();
    });

    modal.addEventListener('close', () => {
      triggers.forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'false');
      });
    });

    modal.addEventListener('click', (event) => {
      if (event.target === modal) {
        modal.close();
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
